import { faker } from '@faker-js/faker'

import { Tag, Treatment } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getTag = asBuilder((): Tag => {
  const name = faker.string.uuid()
  return {
    id: faker.number.int(),
    name,
    label: name,
    tagMeta: {
      name,
      nameKr: faker.lorem.word(),
    },
  }
})

export const getTreatment = asBuilder((): Treatment => {
  const statuses = ['status1', 'status2', 'status3', 'status4']
  const operationTypes = ['operationType1', 'operationType2', 'operationType3', 'operationType4']

  return {
    id: faker.number.int(),
    status: faker.helpers.arrayElement(statuses),
    treatmentTag: getTag(),
    treatmentGroupTags: faker.helpers.multiple(getTag),
    treatmentCategoryTags: faker.helpers.multiple(getTag),
    concernTags: faker.helpers.multiple(getTag),
    concernBodyPartTags: faker.helpers.multiple(getTag),
    equipmentTags: faker.helpers.multiple(getTag),
    materialTags: faker.helpers.multiple(getTag),
    name: faker.string.uuid(),
    label: faker.string.uuid(),
    anesthesias: faker.helpers.multiple(() => faker.lorem.word()),
    operationType: faker.helpers.arrayElement(operationTypes),
    recoveryPeriodDays: faker.number.int(),
    durationPeriodDays: faker.number.int(),
    effectOnSetPeriodDays: faker.number.int(),
    recommendedCycleDays: faker.number.int(),
    painRating: faker.number.int(),
    painDescription: faker.lorem.sentences(),
    sideEffect: faker.lorem.sentences(),
    pros: faker.lorem.sentences(),
    cons: faker.lorem.sentences(),
    recommendedTimes: faker.number.int(),
    caution: faker.lorem.sentences(),
    description: faker.lorem.paragraphs(),
    recommendedTreatments: faker.helpers.multiple(() => ({
      id: faker.number.int(),
      name: faker.string.uuid(),
    })),
    similarTreatments: faker.helpers.multiple(() => ({
      id: faker.number.int(),
      name: faker.string.uuid(),
    })),
  }
})
